<template>
    <v-card :class="$root.$vuetify.theme.isDark ? 'secondary' : ''">
        <validation-observer ref="form" v-slot="{ invalid }">
            <fieldset>
              <v-form @submit.prevent="editCompany == null ? addCompany() : updateCompany()" :disabled="loading">
                <v-card-title :class="$root.$vuetify.theme.isDark ? 'white--text subtitle-1 primary' : 'white--text subtitle-1 primary'">
                    {{$t('supplier.add_company')}}
                </v-card-title>
                <v-card-text>
                  <DialogSuccess :opened="success" @on-ok="success = false; $emit('close');" >
                    {{$t('supplier.company_added')}}
                  </DialogSuccess>
                  <v-row>
                    <v-col cols="12">
                        <validation-provider v-slot="{ errors }" vid="name" :name="$t('globals.name')" rules="required">
                            <v-text-field
                                v-model="company.name"
                                prepend-inner-icon="mdi-account-details"
                                :label="$t('globals.name') + ' *'"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                        <validation-provider v-slot="{ errors }" vid="nif" :name="$t('globals.nif')" rules="required">
                            <v-text-field
                                v-model="company.nif"
                                prepend-inner-icon="mdi-finance"
                                :label="$t('globals.nif') + ' *'"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                        </validation-provider>
                    </v-col>                
                    <v-col cols="12" md="8">
                        <validation-provider v-slot="{ errors }" vid="email" :name="$t('globals.email')" rules="|">
                            <v-text-field
                                v-model="company.email"
                                prepend-inner-icon="mdi-at"
                                :label="$t('globals.email') + ' *'"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                        </validation-provider>
                    </v-col>
                    <v-col cols="12" md="4">
                        <validation-provider v-slot="{ errors }" vid="contact" :name="$t('globals.contact')" rules="|">
                            <v-text-field
                                v-model="company.contact"
                                prepend-inner-icon="mdi-card-account-phone"
                                :label="$t('globals.contact') + ' *'"
                                clearable
                                :error-messages="errors"
                            ></v-text-field>
                        </validation-provider>
                    </v-col>                 
                  </v-row>
                  <v-row>
                    <v-col><small>{{$t('supplier.defect_window')}}</small></v-col>                    
                  </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        depressed
                        @click="$emit('close')"
                    >
                        {{$t('globals.cancel')}}
                    </v-btn>
                    <v-btn :disabled="invalid" depressed :class="$root.$vuetify.theme.isDark ? 'white primary--text' : 'primary'" type="submit">
                        {{$t('globals.save')}}
                    </v-btn> 
                </v-card-actions>
                </v-form>
            </fieldset>            
        </validation-observer>
    </v-card>
</template>
<script>
import DialogSuccess from '@/components/ui/DialogSuccess.vue';
import Company from "@/api/Company.js";

export default {
    components:{
        DialogSuccess
    },
    props:{
        editCompany: Object
    },
    mounted(){
        if(this.editCompany != null){
            this.company.name = this.editCompany.name
            this.company.contact = this.editCompany.contact
            this.company.nif = this.editCompany.nif
            this.company.email = this.editCompany.email
        }
    },
    data(){
        return{
            loading: false,
            success:false,
            company:{
                name: '',
                deleted_company: false,
                contact: null,
                nif: null,
                email: null
            }
        }
    },
    methods:{
        updateCompany(){
            this.loading = true
            Company.update(this.company, this.editCompany.id)
                .then(() => {
                    this.success = true;

                    this.loading = false;

                    this.$emit('close-update')
                });
        },
        addCompany(){
            this.loading = true
            
            Company['create'](this.company).then(() => {

                this.success = true;

                this.loading = false;

                this.$emit('close-update')

                }).catch(err => {
                this.loading = false;

                if(err.response.status == 422) {

                    this.$refs.form.setErrors(err.response.data.errors);
                    
                    return;
                }

                this.error.title = this.$t('globals.error') + " " + err.response.status;

                this.error.message = err.response.data.message;

            });
        }
    }
}
</script>